import { AxiosResponse } from 'axios';
import { ErrorCode } from '@/composables/useDisplayError';

const validateTokenResponse = (response: AxiosResponse): boolean => {
  const invalidityAlertElement = '<form method="post">';
  if (!response.data.includes(invalidityAlertElement)) return false;
  return true;
};

const containsErrors = (response: AxiosResponse): boolean => {
  const errorElement = '<ul class="errorlist';
  return response.data.includes(errorElement);
};

const validateNewPasswordResponse = (response: AxiosResponse): boolean => {
  if (containsErrors(response)) return false;
  return true;
};

const parseErrors = (response: AxiosResponse): string => {
  if (!containsErrors(response)) return '';
  if (response.data.includes(ErrorCode.USER_DOES_NOT_EXIST)) return ErrorCode.USER_DOES_NOT_EXIST;
  if (response.data.includes(ErrorCode.USER_IS_MYWORLD_USER)) return ErrorCode.USER_IS_MYWORLD_USER;
  return '';
};


const resetService = { validateTokenResponse, validateNewPasswordResponse, parseErrors };

export default resetService;